export var FlowType;
(function (FlowType) {
    FlowType["Flow"] = "flow";
    FlowType["Subflow"] = "subflow";
})(FlowType || (FlowType = {}));
